import styled, { keyframes } from 'styled-components';
import { Icon } from '@m12s/component-library';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinningIcon = styled(Icon)`
  animation: ${rotate} 2s linear infinite;
  will-change: transform;
`;

export { SpinningIcon };
